module.exports = ".mat-form-field {\n  width: 140px; }\n"